import { useEffect, useState } from 'react'
import WebsocketManager, { SOCKET_MESSAGES } from 'utils/WebsocketManager'

export type LaserscanData = {
  header?: { frame_id?: string | null; stamp?: { sec?: number; nsec?: number } } | null
  angle_min: number
  angle_max: number
  angle_increment: number
  range_min: number
  range_max: number
  ranges: number[]
}

export function useLaserscanWebSocket(params: {
  enabled: boolean
  robotSerialNumber?: string
  onTimeout?: () => void
}) {
  const { enabled, robotSerialNumber, onTimeout } = params
  const [scan, setScan] = useState<LaserscanData | null>(null)

  useEffect(() => {
    const serial = String(robotSerialNumber || '').trim()
    if (!enabled || !serial) {
      setScan(null)
      return
    }
    let timeoutId: number | null = null

    const clearScanTimeout = () => {
      if (timeoutId) {
        window.clearTimeout(timeoutId)
        timeoutId = null
      }
    }

    const onLaserscan = (data: any) => {
      clearScanTimeout()

      if (data && typeof data.angle_min === 'number' && Array.isArray(data.ranges)) {
        setScan(data)
      } else if (data && data.data && typeof data.data.angle_min === 'number') {
        setScan(data.data)
      }

      timeoutId = window.setTimeout(() => {
        setScan(null)
        if (onTimeout) {
          onTimeout()
        }
      }, 2000)
    }

    WebsocketManager.sendMessage(JSON.stringify({ type: 'laserscan.subscribe', robot_serial_number: serial }))
    WebsocketManager.addEventListener(SOCKET_MESSAGES.ROBOT_LASERSCAN, onLaserscan)

    return () => {
      clearScanTimeout()
      WebsocketManager.removeEventListener(SOCKET_MESSAGES.ROBOT_LASERSCAN, onLaserscan)
      WebsocketManager.sendMessage(JSON.stringify({ type: 'laserscan.unsubscribe', robot_serial_number: serial }))
      setScan(null)
    }
  }, [enabled, robotSerialNumber, onTimeout])

  return { scan }
}
